import { FC } from 'react';

import ReactPlayer from "react-player";
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';

interface ReactPlayerWrapperProps {
    url?: string;
}

const ReactPlayerWrapper: FC<ReactPlayerWrapperProps> = (props) => {
    const { url } = props;

    return (
        <>
        {/* #CC4ALL-7438 forced the file to preload in a hidden component so the second audio element will be able to drag the playing time on the progress bar */}
            <audio controls preload="auto" style={{
                display: "none",
            }}>
                <source src={url} type="audio/wav" />
                Your browser does not support the audio element.
            </audio>

            <ReactPlayer
                url={url}
                preload="auto"
                playing={true}
                controls={true}
                height="50px"
                width="300px"
                style={{ margin: '5px' }}
                playIcon={
                    <PlayCircleOutlineIcon />
                }
            />
        </>
    );
};

export default ReactPlayerWrapper;